import React, {useMemo} from "react";
import ImageRest from "../../../../rest/ImageRest.ts";
import {animated, useSpring} from "@react-spring/web";
import {StandardCard} from "@laser-project/kyui";
import {DedupeAnimationProps} from "./DedupeAnimation.types.ts";

export function DedupeAnimation (props: DedupeAnimationProps)  {
    const imageRest = useMemo(() => new ImageRest(), []);

    console.log("KEEPING", props.children.keep, props.children)
    const {opacity} = useSpring({
        from: {opacity: 1},
        to: {
            opacity: props.children.keep ? 1 : 0.1, // TODO use blur instead
        },
        delay: 500,
        onRest: (props.onComplete ? () => props.onComplete() : undefined)
    })

    return (
        <animated.div style={{
            opacity: opacity,
        }}>
            <StandardCard
                image={imageRest.getUrlById(props.children.imageId)}
                imageAlt={""}
                title={props.children.description}
                chips={props.children.chips}
                type={props.children.entityType}
            />
        </animated.div>
    )
}